document.addEventListener("turbolinks:load", function () {
  ////////////////////////// Modals — hoist to <body>
  // The app shell (#app-wrapper and its flex children) forms a stacking context
  // that traps modals *below* Bootstrap's body-level .modal-backdrop, leaving
  // them visible but unclickable. Moving each modal to <body> puts it in the
  // same stacking context as the backdrop so it layers and closes correctly.
  document.querySelectorAll('.modal').forEach(function (modalEl) {
    if (modalEl.parentElement !== document.body) {
      document.body.appendChild(modalEl);
    }
  });

  ////////////////////////// Close button for notice
  $('#closeActionNotice').click(function() {
    $('#actionNotice').addClass('d-none');
  });

  ////////////////////////// Layout menu toggle
  $("#menu-toggle").click(function(e) {
    e.preventDefault();
    $("#app-wrapper").toggleClass("toggled");
  });

  ////////////////////////// Scrollbar Position
  // var checkSpyScrollbar = $('#sidebar-scroller .nav-item.active');
  // if (checkSpyScrollbar.length) {
  //   var current_scroll_pos = checkSpyScrollbar.position().top;
  //   $("#sidebar-scroller").scrollTop(current_scroll_pos / 2);
  // }

  ////////////////////////// TABS
  var tabsList = [].slice.call(document.querySelectorAll('[role="tablist"]'));
  tabsList.map(function (tabTriggerEl) {
    return new bootstrap.Tab(tabTriggerEl);
  });
  // var triggerFirstTabEl = document.querySelector('#myTab li:first-child a')
  // bootstrap.Tab.getInstance(triggerFirstTabEl).show() // Select first tab
  // $('.nav-tabs a').on('click', function(e) {
  //   e.preventDefault();
  //   $(this).tab('show');
  // });

  ////////////////////////// Tooltips
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  ////////////////////////// Downtime command run-count cost
  // On the Downtime Commands work tabs, the run-count <select> shows how much
  // downtime the batch will spend. Update the visible cost label and the
  // tooltip live as the selection changes, so the player sees the total before
  // submitting. Runs after the tooltip init above so getInstance() is available.
  var runCountSelect = document.querySelector('[data-run-count-select]');
  if (runCountSelect) {
    var costPerRun = parseInt(runCountSelect.dataset.costPerRun, 10) || 5;
    var availableDowntime = parseInt(runCountSelect.dataset.downtime, 10) || 0;
    var costLabel = document.querySelector('[data-run-count-cost]');
    var updateRunCost = function () {
      var times = parseInt(runCountSelect.value, 10) || 1;
      var total = times * costPerRun;
      if (costLabel) { costLabel.textContent = total; }
      var tipText = 'Costs ' + costPerRun + ' downtime each · ' + total +
                    ' total (you have ' + availableDowntime + ')';
      runCountSelect.setAttribute('data-bs-original-title', tipText);
      var tip = bootstrap.Tooltip.getInstance(runCountSelect);
      if (tip) { tip.setContent({ '.tooltip-inner': tipText }); }
    };
    runCountSelect.addEventListener('change', updateRunCost);
    updateRunCost();
  }

  ////////////////////////// Crystal Experience booster flag
  // On DM quest/log forms, show a badge next to a row's XP field when the
  // selected character has an active XP booster (so the DM knows the entered
  // XP will be doubled from that character's pool on save).
  document.querySelectorAll('table[data-crystal-boosters]').forEach(function (table) {
    var boostMap = {}, vipMap = {};
    try { boostMap = JSON.parse(table.getAttribute('data-crystal-boosters') || '{}'); } catch (e) {}
    try { vipMap = JSON.parse(table.getAttribute('data-vip-levels') || '{}'); } catch (e) {}
    // Booster doubling and VIP bonuses only apply to QUEST xp, so both tags only
    // show on a quest group form with "Quest?" checked. Single-log forms have no
    // quest group (never a quest), so the tags stay hidden there.
    var questToggle = document.querySelector('#character_log_group_quest');
    var isQuest = function () { return questToggle ? questToggle.checked : false; };
    var updaters = [];
    table.querySelectorAll('select.character-select').forEach(function (sel) {
      var row = sel.closest('tr');
      var updateFlag = function () {
        if (!row) { return; }
        var quest = isQuest();
        // Crystal booster tag
        var flag = row.querySelector('.crystal-boost-flag');
        if (flag) {
          var remaining = boostMap[sel.value];
          if (quest && remaining !== undefined && remaining !== null) {
            var remEl = flag.querySelector('.crystal-boost-remaining');
            if (remEl) { remEl.textContent = Number(remaining).toLocaleString(); }
            flag.classList.remove('d-none');
          } else {
            flag.classList.add('d-none');
          }
        }
        // VIP level tag
        var vip = row.querySelector('.vip-flag');
        if (vip) {
          var level = vipMap[sel.value];
          if (quest && level) {
            var pctEl = vip.querySelector('.vip-pct');
            if (pctEl) { pctEl.textContent = (Number(level) * 3); }
            vip.classList.remove('d-none');
          } else {
            vip.classList.add('d-none');
          }
        }
      };
      sel.addEventListener('change', updateFlag);
      updaters.push(updateFlag);
      updateFlag();
    });
    if (questToggle) {
      questToggle.addEventListener('change', function () {
        updaters.forEach(function (fn) { fn(); });
      });
    }
  });

  ////////////////////////// VIP XP reference calculator
  // Non-submitted helper on the group log form: DM types a base quest XP and
  // sees the VIP-adjusted values (+3% / +6% / +9%) to reference when filling in
  // each character's XP field.
  document.querySelectorAll('[data-vip-calc]').forEach(function (calc) {
    var input = calc.querySelector('[data-vip-xp-input]');
    if (!input) { return; }
    var out3 = calc.querySelector('[data-vip-3]');
    var out6 = calc.querySelector('[data-vip-6]');
    var out9 = calc.querySelector('[data-vip-9]');
    var update = function () {
      var base = parseFloat(input.value) || 0;
      if (out3) { out3.textContent = Math.round(base * 1.03).toLocaleString(); }
      if (out6) { out6.textContent = Math.round(base * 1.06).toLocaleString(); }
      if (out9) { out9.textContent = Math.round(base * 1.09).toLocaleString(); }
    };
    input.addEventListener('input', update);
    update();
  });

  ////////////////////////// SCROLLER
  const scrollSpy = new bootstrap.ScrollSpy(document.body, {
    target: '#scrollTrackingList'
  });

  ////////////////////////// Popovers
  // $(function () { $('[data-bs-toggle="popover"]').popover(); });
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  const popoversRun = [...popoverTriggerList].map(popoverTriggerEl => {
    return new bootstrap.Popover(popoverTriggerEl);
  });
  popoversRun;
  // Hide all popovers on any outside click
  $('body').on('click', function (e) {
    $('[data-bs-toggle=popover]').each(function () {
      // hide any open popovers when the anywhere else in the body is clicked
      if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
        $(this).popover('hide');
      }
    });
  });
});


// ---- Copy-to-clipboard for [data-copy-target] buttons ----
// Attached ONCE at module load (outside turbolinks:load) via event delegation,
// so it survives Turbolinks navigations and modals being hoisted to <body>.
document.addEventListener("click", function (e) {
  var btn = e.target.closest("[data-copy-target]");
  if (!btn) { return; }
  var target = document.querySelector(btn.getAttribute("data-copy-target"));
  if (!target) { return; }
  var text = (target.value !== undefined) ? target.value : target.textContent;
  var flash = function () {
    var original = btn.getAttribute("data-copy-label") || btn.textContent;
    btn.setAttribute("data-copy-label", original);
    btn.textContent = "Copied!";
    setTimeout(function () { btn.textContent = original; }, 1500);
  };
  var fallback = function () {
    try { target.removeAttribute("readonly"); target.focus(); target.select(); document.execCommand("copy"); target.setAttribute("readonly", "readonly"); flash(); } catch (err) {}
  };
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(flash, fallback);
  } else {
    fallback();
  }
});


// ---- Loan payment amount cap ----
// On the Make a Payment modal, cap the amount input to the selected loan's
// remaining balance (each <option> carries data-remaining). Delegated at module
// load so it survives Turbolinks navigations and the modal being hoisted to
// <body>. Prevents players typing more than is owed (the server also clamps).
function loanSelectedMax(sel) {
  var opt = sel.options[sel.selectedIndex];
  if (!opt) { return null; }
  var r = parseInt(opt.getAttribute("data-remaining"), 10);
  return isNaN(r) ? null : r;
}
function loanAmountInputFor(sel) {
  var scope = sel.closest("form") || document;
  return scope.querySelector("[data-loan-amount-input]");
}
document.addEventListener("change", function (e) {
  var sel = e.target.closest ? e.target.closest("[data-loan-amount-select]") : null;
  if (!sel) { return; }
  var inp = loanAmountInputFor(sel);
  if (!inp) { return; }
  var max = loanSelectedMax(sel);
  if (max === null) { inp.removeAttribute("max"); return; }
  inp.setAttribute("max", max);
  if (inp.value !== "" && parseInt(inp.value, 10) > max) { inp.value = max; }
});
document.addEventListener("input", function (e) {
  var inp = e.target.closest ? e.target.closest("[data-loan-amount-input]") : null;
  if (!inp) { return; }
  var max = parseInt(inp.getAttribute("max"), 10);
  if (!isNaN(max) && inp.value !== "" && parseInt(inp.value, 10) > max) { inp.value = max; }
});
